export const PatientCreateSteps = {
  PATIENT_INTRO: 'patient-intro',
  // Workflow 1 - Phone number is new to this IDN
  PATIENT_INFORMATION: 'patient-information',
  PATIENT_SETTINGS: 'patient-settings',
  // Workflow 2 - Phone number exists in a ANOTHER department
  PATIENT_ANOTHER_DEPARTMENT_ACCOUNT_FOUND:
    'patient-another-department-accounts-found',
  // Workflow 3 - Phone number exists in CURRENT department patient list
  PATIENT_ALREADY_EXISTS: 'patient-already-exists',
  // Workflow 4 - Phone number exists in CURRENT department archive list
  PATIENT_ARCHIVED_ACCOUNT_FOUND: 'patient-archived-account-was-found',
} as const;

export const PatientInformationInviteLabels = {
  text: 'Text Message',
  email: 'Email',
} as const;
